import React, { useState } from "react";
import CustomModal from "./CustomModal";
import AuthInput from "../Input/AuthInput";
import AddingLightLoader from "../Loaders/AddingLightLoader";
import { ErrorToast, SuccessToast, WarningToast } from "../../utils/ShowToast";
import { CreateProductApi, EditProductApi } from "../../ApiRequests"; // Updated API function
import AuthBtn from "../Buttons/AuthBtn";
import { useDispatch } from "react-redux";
import { fetchProducts } from "../../store/Slices/ProductSlice";
import CompanySelector from "../Selector/CompanySelector";
import UnitSelector from "../Selector/UnitSelector";

const EditProductModal = ({ Open, setOpen, currentProduct }) => {
  const [ItemCode, setItemCode] = useState(currentProduct.code || "");
  const [ItemName, setItemName] = useState(currentProduct.name || "");
  const [SelectedSupplier, setSelectedSupplier] = useState(
    currentProduct.companyId || ""
  );
  const [SelectedUnit, setSelectedUnit] = useState(currentProduct.unit || "");
  const [ItemPurchase, setItemPurchase] = useState(
    currentProduct.purchase || ""
  );
  const [ItemSale, setItemSale] = useState(currentProduct.sale || "");
  const [ItemSaleShop, setItemSaleShop] = useState(
    currentProduct.sale_shop || ""
  );
  const [ProductName, setProductName] = useState(
    currentProduct ? currentProduct.name : ""
  );
  const [ProductCode, setProductCode] = useState(
    currentProduct ? currentProduct.code : ""
  );
  const [Price, setPrice] = useState(
    currentProduct ? currentProduct.price : ""
  );
  const [ML, setML] = useState(currentProduct ? currentProduct.net_vol : "");
  const [Loading, setLoading] = useState(false);

  const dispatch = useDispatch();

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (ItemName === "") {
      WarningToast("Enter a valid Item name");
    } else if (ItemCode === "") {
      WarningToast("Enter a valid Item code");
    } else if (ItemSale === "" || isNaN(ItemSale) || ItemSale <= 0) {
      WarningToast("Enter a valid price");
    } else if (
      ItemSaleShop === "" ||
      isNaN(ItemSaleShop) ||
      ItemSaleShop <= 0
    ) {
      WarningToast("Enter a valid shop sale price");
    } else {
      try {
        const response = await EditProductApi(currentProduct._id, {
          code: ItemCode.toUpperCase(),
          name: ItemName,
          companyId: SelectedSupplier._id,
          unit: SelectedUnit,
          purchase: ItemPurchase,
          sale: ItemSale,
          sale_shop: ItemSaleShop,
        });

        if (response.data.success) {
          setOpen(false);
          SuccessToast("Product updated successfully");
          dispatch(fetchProducts());
        } else {
          ErrorToast(response.data.error?.msg);
        }
      } catch (err) {
        console.log(err);
        ErrorToast("Failed to updated Product");
      }
    }
    setLoading(false);
  };

  return (
    <CustomModal open={Open} setOpen={setOpen}>
      <div className="pb-8">
        <h1 className="w-full text-center font-[700] text-3xl py-8">
          Update Product
        </h1>
        <div className="flex flex-col px-10 gap-y-4">
          <CompanySelector
            SelectedSupplier={SelectedSupplier}
            setSelectedSupplier={setSelectedSupplier}
          />
          <UnitSelector
            SelectedUnit={SelectedUnit}
            setSelectedUnit={setSelectedUnit}
          />
          <AuthInput
            label="Item Name"
            placeholder="Enter Item Name"
            Value={ItemName}
            setValue={setItemName}
          />
          <AuthInput
            label="Item Code"
            placeholder="Enter Item Code"
            Value={ItemCode}
            setValue={setItemCode}
          />
          <AuthInput
            label="Purchase"
            placeholder="Enter Purchase Amount"
            Value={ItemPurchase}
            setValue={setItemPurchase}
            type="number"
          />
          <AuthInput
            label="Sale"
            placeholder="Enter Sale"
            Value={ItemSale}
            setValue={setItemSale}
            type="number"
          />
          <AuthInput
            label="Sale Shop"
            placeholder="Enter Sale Shop"
            Value={ItemSaleShop}
            setValue={setItemSaleShop}
            type="number"
          />
        </div>
        <div className="flex justify-center items-center gap-x-2 mt-5 px-5">
          {Loading ? (
            <AddingLightLoader />
          ) : (
            <>
              <AuthBtn title={"Update Product"} onSubmit={onSubmit} type={1} />
              <AuthBtn
                title={"Cancel"}
                onSubmit={() => setOpen(false)}
                type={2}
              />
            </>
          )}
        </div>
      </div>
    </CustomModal>
  );
};

export default EditProductModal;
